<template>
  <a-form
    layout="horizontal"
    :label-col="labelCol"
    :wrapper-col="wrapperCol"
    :colon="false"
    :form="form"
  >
    <h4>联系方式<span class="desc">(手机/邮箱可二选一)</span></h4>
    <a-row>
      <a-col :md="12" :sm="24">
        <mobile-input
          label="手机号"
          :form="form"
          :validateHandler="handleFieldValidate"
          phoneKey="registerAgentUserInfo.phone"
          areaCodeKey="registerAgentUserInfo.areaCode"
          @change="onPhoneChange"
          :isInit="type !== 'new'"
        ></mobile-input>
      </a-col>
      <a-col :md="12" :sm="24">
        <a-form-item label="电子邮箱">
          <a-input
            size="large"
            placeholder="请输入电子邮箱"
            v-decorator="[
              'registerAgentUserInfo.email',
              {
                rules: [
                  {
                    validator: handleFieldValidate
                  }
                ],
                validateTrigger: 'blur'
              }
            ]"
            @blur="onEmailChange"
          >
          </a-input>
        </a-form-item>
      </a-col>
    </a-row>
    <a-row>
      <a-col :md="12" :sm="24">
        <a-form-item required v-if="phone || !email" label="手机验证码">
          <user-verification-code placeholder="请输入手机动态码" size="large" actionText="获取手机动态码" :smsType="8" :areaCode="areaCode" :value="phone" :token="token" handlerErrorBySelf @change="onVerificationCodeChange" @error="onVerificationCodeError">
          </user-verification-code>
        </a-form-item>
        <a-form-item required v-if="!phone && email" label="邮箱验证码">
          <user-verification-code placeholder="请输入邮箱动态码" size="large" actionText="获取邮箱动态码" type="email" :smsType="9" :value="email" :token="token" handlerErrorBySelf @change="onVerificationCodeChange" @error="onVerificationCodeError">
          </user-verification-code>
        </a-form-item>
      </a-col>
      <a-col :md="12" :sm="24">
        <a-form-item required label="验证码">
          <user-slider-captcha ref="verify" size="large" @change="onCaptchVerify">
          </user-slider-captcha>
        </a-form-item>
      </a-col>
    </a-row>
    <h4>账号密码设置</h4>
    <a-row>
      <a-col :md="12" :sm="24">
        <a-form-item required label="用户名">
          <a-input
            size="large"
            placeholder="请输入用户名,长度6-40位"
            v-decorator="[
              'registerAgentUserInfo.login',
              {
                rules: [
                  {
                    validator: handleFieldValidate
                  }
                ],
                validateTrigger: 'blur'
              }
            ]"
            :disabled="type === 'modify'"
          >
          </a-input>
        </a-form-item>
      </a-col>
    </a-row>
    <a-row>
      <a-col :md="12" :sm="24">
        <a-form-item required label="中文姓">
          <a-input
            size="large"
            placeholder="请输入中文姓"
            v-decorator="[
              'registerAgentUserInfo.chiSurname',
              {
                rules: [
                  {
                    validator: handleFieldValidate
                  }
                ],
                validateTrigger: 'blur'
              }
            ]"
          >
          </a-input>
        </a-form-item>
      </a-col>
      <a-col :md="12" :sm="24">
        <a-form-item required label="中文名">
          <a-input
            size="large"
            placeholder="请输入中文名"
            v-decorator="[
              'registerAgentUserInfo.chiName',
              {
                rules: [
                  {
                    validator: handleFieldValidate
                  }
                ],
                validateTrigger: 'blur'
              }
            ]"
          >
          </a-input>
        </a-form-item>
      </a-col>
    </a-row>
    <a-row v-if="type === 'new'">
      <a-col :md="12" :sm="24">
        <a-form-item required label="密码">
          <a-input
            size="large"
            placeholder="请输入密码"
            type="password"
            v-decorator="[
              'registerAgentUserInfo.password',
              {
                rules: [
                  {
                    validator: handleFieldValidate
                  }
                ],
                validateTrigger: 'blur'
              }
            ]"
          >
          </a-input>
        </a-form-item>
      </a-col>
      <a-col :md="12" :sm="24">
        <a-form-item required label="确认密码">
          <a-input
            size="large"
            placeholder="请再次输入密码"
            type="password"
            v-decorator="[
              'registerAgentUserInfo.confirmPassword',
              {
                rules: [
                  {
                    validator: handleFieldValidate
                  }
                ],
                validateTrigger: 'blur'
              }
            ]"
          >
          </a-input>
        </a-form-item>
      </a-col>
    </a-row>
  </a-form>
</template>

<script>
import { validate } from '@/utils/validate'
import eventBus from '../../../components/eventBus.js'

const verifyItems = {
  'registerAgentUserInfo.phone': 100,
  'registerAgentUserInfo.login': 101,
  'registerAgentUserInfo.email': 103
}

export default {
  props: {
    type: {
      type: String,
      default: 'new'
    }
  },
  data () {
    return {
      labelCol: {
        span: 5
      },
      wrapperCol: {
        span: 18
      },
      form: this.$form.createForm(this),
      phone: '',
      areaCode: '',
      email: '',
      token: '',
      finalToken: '',
      code: '',
      errCode: ''
    }
  },
  created () {
    eventBus.$on('get-token', (value) => {
      this.onGetFinalToken(value)
    })
  },
  methods: {
    handleFieldValidate (rule, value, callback) {
      validate(this.type === 'new' ? 'agent-user' : 'agent-user-modify', this.form.getFieldsValue(), rule.fullField).then(({ valid, error }) => {
        const idx = verifyItems[rule.fullField]

        if (!error && idx && value) {
          return this.$emit('verify', value, idx, callback)
        }

        if (valid) {
          callback()
        } else {
          callback(error)
        }
      })
    },
    onPhoneChange ({ areaCode, phone }) {
      this.areaCode = areaCode
      this.phone = phone
    },
    onEmailChange () {
      this.form.validateFields(['registerAgentUserInfo.email'], (errors, values) => {
        if (!errors) {
          this.email = values.registerAgentUserInfo.email
        } else {
          this.email = ''
        }
      })
    },
    onCaptchVerify (value) {
      this.token = value
      if (this.errCode.toString().includes(1000)) {
        this.finalToken = value
      }
    },
    onVerificationCodeChange (value) {
      this.code = value
    },
    onVerificationCodeError (err) {
      this.$error({
        content: err.message,
        centered: true
      })
    },
    modifyInit (phone = '', email = '') {
      this.phone = phone
      this.email = email
    },
    onGetFinalToken (value) {
      this.finalToken = value
      this.errCode = ''
    }
  }
}
</script>
